import { render, staticRenderFns } from "./Fax.vue?vue&type=template&id=a9fa3404&"
import script from "./Fax.vue?vue&type=script&lang=js&"
export * from "./Fax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports